import * as React from "react";
import { ComponentType, LazyExoticComponent } from "react";

// Matches AEM enum be.hubo.hubofoundation.ssr.SsrComponentName
export enum SsrComponent {
    HEADER_BUTTON = "HEADER_BUTTON",
    SHOP_FINDER_HEADER_BUTTON = "SHOP_FINDER_HEADER_BUTTON",
    ACCOUNT_BUTTON = "ACCOUNT_BUTTON",
    CART_BUTTON = "CART_BUTTON",
    WISHLIST_HEADER_BUTTON = "WISHLIST_HEADER_BUTTON",
    PRODUCT_COMPARISON = "PRODUCT_COMPARISON",
    PRODUCT_COMPARISON_BAR = "PRODUCT_COMPARISON_BAR",
    LANGUAGE_SELECTOR = "LANGUAGE_SELECTOR",
    FLYOUT_BUTTON = "FLYOUT_BUTTON",
    SAFETY_INFO = "SAFETY_INFO",
    IMAGE_VIEWER = "IMAGE_VIEWER",
    IMAGE_VIEWER_FULL_WIDTH = "IMAGE_VIEWER_FULL_WIDTH",
    PRODUCT_SLIDER = "PRODUCT_SLIDER",
    PRODUCT_TILE = "PRODUCT_TILE",
    CATEGORIES_SLIDER = "CATEGORIES_SLIDER",
    DEBUG_NOTIFICATION = "DEBUG_NOTIFICATION",
    E_COMMERCE = "E_COMMERCE",
    SEARCH_BAR = "SEARCH_BAR",
    PRODUCT_BUNDLES = "PRODUCT_BUNDLES",
    STORE_LOCATOR_MOBILE = "STORE_LOCATOR_MOBILE",
    CALL_TO_ACTION = "CALL_TO_ACTION",
    PRODUCT_PAGE = "PRODUCT_PAGE",
    FEATURE_SWITCH = "FEATURE_SWITCH",
    STORE_SEARCH = "STORE_SEARCH",
    STORE_DIRECTIONS = "STORE_DIRECTIONS",
    NEWSLETTER = "NEWSLETTER",
    NEWSLETTER_SUBSCRIPTION = "NEWSLETTER_SUBSCRIPTION",
    LOGIN_FORM = "LOGIN_FORM",
    REGISTER_FORM = "REGISTER_FORM",
    REGISTER_CHECKOUT_FORM = "REGISTER_CHECKOUT_FORM",
    FRANCHISE_REQUEST = "FRANCHISE_REQUEST",
    CONTACT_CUSTOMER_SERVICE = "CONTACT_CUSTOMER_SERVICE",
    CREATE_GIFT_CARD = "CREATE_GIFT_CARD",
    BUSINESS_GIFT_CARD_REQUEST = "BUSINESS_GIFT_CARD_REQUEST",
    GIFT_CARD_REQUEST_BALANCE = "GIFT_CARD_REQUEST_BALANCE",
    BONUS_CARD_REQUEST = "BONUS_CARD_REQUEST",
    BONUS_CARD_REQUEST_BALANCE = "BONUS_CARD_REQUEST_BALANCE",
    CUSTOMER_LOAD = "CUSTOMER_LOAD",
    QUIZZI_APPOINTMENT = "QUIZZI_APPOINTMENT",
    SEARCH_RESULTS = "SEARCH_RESULTS",
    RECOVERABILITY_INDEX = "RECOVERABILITY_INDEX",
    E_CORNER_PAYMENT = "E_CORNER_PAYMENT",
    ADD_TO_CART_MODAL = "ADD_TO_CART_MODAL",
    KEY_FEATURES = "KEY_FEATURES",
    IMAGE = "IMAGE",
    IMAGE_LINK = "IMAGE_LINK",
    PRODUCT_FEATURES = "PRODUCT_FEATURES",
    BANNER_SLIDER = "BANNER_SLIDER",
    BRAND_LOGO = "BRAND_LOGO",
    PAINT_CONFIGURATOR = "PAINT_CONFIGURATOR",
    CONTENT_CARD = "CONTENT_CARD",
    STORE_FEATURES = "STORE_FEATURES",
    INFO_CARD = "INFO_CARD",
    WITHDRAWAL_FORM = "WITHDRAWAL_FORM",
    GUARANTEE_NOTICE_MODAL = "GUARANTEE_NOTICE_MODAL"
}

const LanguageSelector = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/General/LanguageSelector/languageSelector.container"
    ).then((module) => ({
        default: module.LanguageSelectorContainer
    }))
);
const FlyoutButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Navigation/Flyout/flyoutButton.container"
    ).then((module) => ({
        default: module.FlyoutButtonContainer
    }))
);
const SafetyInfo = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/SafetyInfo/safetyInfo.container"
    ).then((module) => ({
        default: module.SafetyInfoContainer
    }))
);
const ImageViewer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ImageViewer/imageViewer.container"
    ).then((module) => ({
        default: module.ImageViewerContainer
    }))
);
const ImageViewerFullWidth = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Product/ImageViewerFullWidth/imageViewerFullWidth.container"
    ).then((module) => ({
        default: module.ImageViewerFullWidth
    }))
);
const ProductSlider = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ProductSlider/productSlider.default"
    ).then((module) => ({
        default: module.ProductSliderDefault
    }))
);
const ProductTile = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ProductTile/productTile.adapter"
    ).then((module) => ({
        default: module.ProductTileAdapter
    }))
);
const CategoriesSlider = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/Categories/categorySlider.container"
    ).then((module) => ({
        default: module.CategoriesContainer
    }))
);
const AccountButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/AccountButton/accountButton.container"
    ).then((module) => ({
        default: module.AccountButton
    }))
);
const ProductComparison = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ProductComparison/productComparison.container"
    ).then((module) => ({
        default: module.ProductComparisonContainer
    }))
);
const ProductComparisonBar = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ProductComparisonBar/productComparisonBar.default"
    ).then((module) => ({
        default: module.ProductComparisonBarDefault
    }))
);
const WishlistHeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/WishlistButton/wishlistButton.container"
    ).then((module) => ({
        default: module.WishlistButton
    }))
);
const CartButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/CartButton/cartButton.container"
    ).then((module) => ({
        default: module.CartButton
    }))
);
const HeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/HeaderButton/headerButton.container"
    ).then((module) => ({
        default: module.HeaderButton
    }))
);
const ShopFinderHeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/StoreFinderButton/storeFinderButton.container"
    ).then((module) => ({
        default: module.StoreFinderButton
    }))
);
const DebugNotification = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Utils/debugNotifiction/debugNotification.component"
    ).then((module) => ({
        default: module.DebugNotification
    }))
);
const ECommerce = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Product/ECommerce/eCommerce.container"
    ).then((module) => ({
        default: module.ECommerceContainer
    }))
);
const SearchBar = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Search/SearchBar/searchBar.container"
    ).then((module) => ({
        default: module.SearchBar
    }))
);
const ProductBundles = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ProductBundles/productBundles.container"
    ).then((module) => ({
        default: module.ProductBundles
    }))
);

const ProductPage = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Product/ProductPage/productPage.container"
    ).then((module) => ({
        default: module.ProductPageContainer
    }))
);

const StoreLocatorMobile = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Store/StoreLocatorMobile/storeLocatorMobile.container"
    ).then((module) => ({
        default: module.StoreLocatorMobileContainer
    }))
);

const CallToAction = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/CallToAction/callToAction.container"
    ).then((module) => ({
        default: module.CallToAction
    }))
);

const FeatureSwitch = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Utils/featureSwitch/featureSwitch.container"
    ).then((module) => ({
        default: module.FeatureSwitchContainer
    }))
);

const StoreSearch = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Store/StoreSearch/storeSearch.container"
    ).then((module) => ({
        default: module.StoreSearch
    }))
);

const StoreDirections = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Store/StoreDirections/storeDirections.container"
    ).then((module) => ({
        default: module.StoreDirections
    }))
);

const Newsletter = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Newsletter/newsletter.container"
    ).then((module) => ({
        default: module.NewsletterContainer
    }))
);

const NewsletterSubscription = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/NewsletterSubscription/newsletterSubscription.container"
    ).then((module) => ({
        default: module.NewsletterSubscription
    }))
);

const LoginForm = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Account/LoginForm/loginForm.container"
    ).then((module) => ({
        default: module.LoginFormContainer
    }))
);

const RegisterForm = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Account/RegisterForm/registerForm.container"
    ).then((module) => ({
        default: module.RegisterFormContainer
    }))
);

const RegisterCheckoutForm = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Checkout/RegisterCheckoutForm/registerCheckoutForm.container"
    ).then((module) => ({
        default: module.RegisterCheckoutForm
    }))
);

const FranchiseRequest = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/FranchiseRequest/franchiseRequest.container"
    ).then((module) => ({
        default: module.FranchiseRequestContainer
    }))
);

const ContactCustomerservice = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/ContactCustomerservice/contactCustomerservice.container"
    ).then((module) => ({ default: module.ContactCustomerserviceContainer }))
);

const CreateGiftCard = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/CreateGiftCard/createGiftCard.container"
    ).then((module) => ({ default: module.CreateGiftCardContainer }))
);

const BusinessGiftCardRequest = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/BusinessGiftCardRequest/businessGiftCardRequest.container"
    ).then((module) => ({ default: module.BusinessGiftCardRequestContainer }))
);

const GiftCardRequestBalance = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/GiftCardRequestBalance/giftCardRequestBalance.container"
    ).then((module) => ({
        default: module.GiftCardRequestBalanceContainer
    }))
);

const BonusCardRequest = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Account/BonusCardRequest/bonusCardRequest.container"
    ).then((module) => ({ default: module.BonusCardRequestContainer }))
);

const BonusCardRequestBalance = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/BonusCardRequestBalance/bonusCardRequestBalance.container"
    ).then((module) => ({ default: module.BonusCardRequestBalanceContainer }))
);

const CustomerLoad = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Customer/load.component"
    ).then((module) => ({ default: module.CustomerLoad }))
);

const QuizziAppointment = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/ContactQuizzi/quizziAppointment.container"
    ).then((module) => ({ default: module.QuizziAppointment }))
);

const SearchResults = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@/components/Search/SearchResults/searchResults.container"
    ).then((module) => ({ default: module.SearchResultsContainer }))
);

const RepairabilityIndex = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/RepairabilityIndex/repairabilityIndex"
    ).then((module) => ({ default: module.RepairabilityIndex }))
);

const ECornerPayment = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Checkout/ECornerPayment/eCornerPayment.container"
    ).then((module) => ({ default: module.ECornerPayment }))
);

const AddToCartModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Modals/AddToCartModal/addToCartModal.container"
    ).then((module) => ({ default: module.AddToCartModal }))
);

const KeyFeatures = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Product/Feature/KeyFeatures/keyFeatures.container"
    ).then((module) => ({ default: module.KeyFeatures }))
);

const Image = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/Image/image.default"
    ).then((module) => ({ default: module.ImageDefault }))
);

const ImageLink = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/ImageLink/imageLink"
    ).then((module) => ({ default: module.ImageLink }))
);

const ProductFeatures = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/ProductPage/components/productInfo/sections/featureList/featureList"
    ).then((module) => ({ default: module.FeatureList }))
);

const BannerSlider = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/BannerSlider/bannerSlider.container"
    ).then((module) => ({ default: module.BannerSlider }))
);

const BrandLogo = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/ProductPage/components/brandLogo/brandLogo.component"
    ).then((module) => ({ default: module.BrandLogoComponent }))
);

const PaintConfigurator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/PaintConfigurator/paintConfigurator.default"
    ).then((module) => ({ default: module.PaintConfiguratorDefault }))
);

const ContentCard = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/General/ContentCard/contentCard.component"
    ).then((module) => ({ default: module.ContentCard }))
);

const StoreFeatures = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Store/StoreFeatures/storeFeatures.default"
    ).then((module) => ({ default: module.StoreFeaturesDefault }))
);

const InfoCard = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/InfoCard/infoCard.default"
    ).then((module) => ({ default: module.InfoCardDefault }))
);

const WithdrawalForm = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/WithdrawalForm/withdrawalForm.container"
    ).then((module) => ({ default: module.WithdrawalForm }))
);

const GuaranteeNoticeModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Modals/GuaranteeNoticeModal/guaranteeNoticeModal"
    ).then((module) => ({ default: module.GuaranteeNoticeModal }))
);

export const SsrComponentMap: Record<
    SsrComponent,
    LazyExoticComponent<ComponentType<any>>
> = {
    [SsrComponent.HEADER_BUTTON]: HeaderButton,
    [SsrComponent.SHOP_FINDER_HEADER_BUTTON]: ShopFinderHeaderButton,
    [SsrComponent.ACCOUNT_BUTTON]: AccountButton,
    [SsrComponent.CART_BUTTON]: CartButton,
    [SsrComponent.WISHLIST_HEADER_BUTTON]: WishlistHeaderButton,
    [SsrComponent.PRODUCT_COMPARISON]: ProductComparison,
    [SsrComponent.PRODUCT_COMPARISON_BAR]: ProductComparisonBar,
    [SsrComponent.LANGUAGE_SELECTOR]: LanguageSelector,
    [SsrComponent.FLYOUT_BUTTON]: FlyoutButton,
    [SsrComponent.SAFETY_INFO]: SafetyInfo,
    [SsrComponent.IMAGE_VIEWER]: ImageViewer,
    [SsrComponent.IMAGE_VIEWER_FULL_WIDTH]: ImageViewerFullWidth,
    [SsrComponent.PRODUCT_SLIDER]: ProductSlider,
    [SsrComponent.PRODUCT_TILE]: ProductTile,
    [SsrComponent.CATEGORIES_SLIDER]: CategoriesSlider,
    [SsrComponent.DEBUG_NOTIFICATION]: DebugNotification,
    [SsrComponent.E_COMMERCE]: ECommerce,
    [SsrComponent.SEARCH_BAR]: SearchBar,
    [SsrComponent.PRODUCT_BUNDLES]: ProductBundles,
    [SsrComponent.STORE_LOCATOR_MOBILE]: StoreLocatorMobile,
    [SsrComponent.CALL_TO_ACTION]: CallToAction,
    [SsrComponent.PRODUCT_PAGE]: ProductPage,
    [SsrComponent.FEATURE_SWITCH]: FeatureSwitch,
    [SsrComponent.STORE_SEARCH]: StoreSearch,
    [SsrComponent.STORE_DIRECTIONS]: StoreDirections,
    [SsrComponent.NEWSLETTER]: Newsletter,
    [SsrComponent.NEWSLETTER_SUBSCRIPTION]: NewsletterSubscription,
    [SsrComponent.LOGIN_FORM]: LoginForm,
    [SsrComponent.REGISTER_FORM]: RegisterForm,
    [SsrComponent.REGISTER_CHECKOUT_FORM]: RegisterCheckoutForm,
    [SsrComponent.FRANCHISE_REQUEST]: FranchiseRequest,
    [SsrComponent.CONTACT_CUSTOMER_SERVICE]: ContactCustomerservice,
    [SsrComponent.CREATE_GIFT_CARD]: CreateGiftCard,
    [SsrComponent.BUSINESS_GIFT_CARD_REQUEST]: BusinessGiftCardRequest,
    [SsrComponent.GIFT_CARD_REQUEST_BALANCE]: GiftCardRequestBalance,
    [SsrComponent.BONUS_CARD_REQUEST]: BonusCardRequest,
    [SsrComponent.BONUS_CARD_REQUEST_BALANCE]: BonusCardRequestBalance,
    [SsrComponent.CUSTOMER_LOAD]: CustomerLoad,
    [SsrComponent.QUIZZI_APPOINTMENT]: QuizziAppointment,
    [SsrComponent.SEARCH_RESULTS]: SearchResults,
    [SsrComponent.RECOVERABILITY_INDEX]: RepairabilityIndex,
    [SsrComponent.E_CORNER_PAYMENT]: ECornerPayment,
    [SsrComponent.ADD_TO_CART_MODAL]: AddToCartModal,
    [SsrComponent.KEY_FEATURES]: KeyFeatures,
    [SsrComponent.IMAGE]: Image,
    [SsrComponent.IMAGE_LINK]: ImageLink,
    [SsrComponent.PRODUCT_FEATURES]: ProductFeatures,
    [SsrComponent.BANNER_SLIDER]: BannerSlider,
    [SsrComponent.BRAND_LOGO]: BrandLogo,
    [SsrComponent.PAINT_CONFIGURATOR]: PaintConfigurator,
    [SsrComponent.CONTENT_CARD]: ContentCard,
    [SsrComponent.STORE_FEATURES]: StoreFeatures,
    [SsrComponent.INFO_CARD]: InfoCard,
    [SsrComponent.WITHDRAWAL_FORM]: WithdrawalForm,
    [SsrComponent.GUARANTEE_NOTICE_MODAL]: GuaranteeNoticeModal
};
